import React from "react";
import { connect } from "react-redux";
import { useMediaQuery, useTheme } from '@mui/material';

import Jotform from 'react-jotform';

function IndiSupport(props) {
   const platform = localStorage.getItem("indi-platform");
   const isUsingApp = platform && (platform === "ios-app" || platform === "android-app");

   const theme = useTheme()
   const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

   const { account } = props.User;

   let first_last_name = account?.user?.first_name ? (account?.user?.first_name + " " + account?.user?.last_name) : "";
   let username = account?.user?.user_name || "";
   let device = isUsingApp ? platform : "web-app"
   let user_email = account?.user?.email_address || "";

   return (
      <div style={{ paddingTop: '1px' }}>
         <div id="indi-support-content" className="page-content-v2 flex-c">

            <div style={{ width: isMobile ? "350px" : "600px", marginTop: "10px", zIndex: isMobile ? "unset" : 8 }}>

               <Jotform
                  src="https://form.jotform.com/230884849101055"
                  defaults={{
                     first_last_name: first_last_name,
                     username: username,
                     device: device,
                     user_email: user_email
                  }}
               />
            </div>

         </div>

      </div>
   );
}

const mapStateToProps = (state) => ({
   User: state.User,
});

export default connect(mapStateToProps, {

})(IndiSupport);

